import { ChakraProvider, Icon, IconButton, Box } from "@chakra-ui/react";
import theme from "../../theme";
import { AiFillDelete } from "react-icons/ai";
import { useModelStore, usePlacedModelsStore } from "../../store";
import useIsMobile from "../Hooks/useIsMobile";

export default function TransformToolsCircular() {
  const selected = useModelStore((s) => s.selectedMeshes);
  const setSelectedMeshes = useModelStore((s) => s.setSelectedMeshes);
  const removeModel = usePlacedModelsStore((s) => s.removeModel);
  const isMobile = useIsMobile();
  return (
    <ChakraProvider value={theme}>
      <Box
        position="relative"
        w="0"
        h="0"
        display="flex"
        onPointerDown={(e) => e.stopPropagation()} // prevent propagation
        onPointerMove={(e) => e.stopPropagation()}
      >
        <IconButton
          aria-label={"delete"}
          size="lg"
          position="absolute"
          top={isMobile ? "-6vh" : "-20vh"}
          left={isMobile ? undefined : "120px"}
          transform="translate(-50%, -50%)"
          colorPalette={"red"}
          color={"white"}
          variant={"solid"}
          bg={"red"}
          onClick={(e) => {
            e.stopPropagation(); // prevent canvas clicks
            setSelectedMeshes([]);
            removeModel(selected?.[0]?.userData?.sourceId);
          }}
        >
          <Icon as={AiFillDelete} />
        </IconButton>
      </Box>
    </ChakraProvider>
  );
}
